import AppImage from '@theme/components/atom/AppImage'
import Wysiwyg from '@theme/components/utils/Wysiwyg'

export default {
  components: { AppImage, Wysiwyg },
  props: {
    accordion: {
      type: Object,
      required: true,
    },
    variant: {
      type: String,
      default: 'base',
      validator: v => ['base', 'faq'].includes(v),
    },
    openFirst: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      accordionVisible: false,
    }
  },
  mounted() {
    this.accordionVisible = !!this.openFirst
  },
  methods: {
    toggleAccordion() {
      this.accordionVisible = !this.accordionVisible
    },
  },
}
